import React, { Component } from 'react';
import { connect } from 'react-redux'
import { updateTerm } from '../../../stores/actions/infoAction';

class EditTermAndCondition extends Component{

    constructor(props){
        super(props)
        this.state = {
            infoName: this.props.info.infoName,
            infoType: this.props.info.infoType,
            infoContent: this.props.info.infoContent,
        
            isLoading: null,
            message: null,
        }
        this.baseState = this.state 
    }

    componentDidUpdate = (prevProps, prevState) => { 
        const { updateTermError, updateTermSuccess } = this.props;

        if(prevProps.updateTermError !== updateTermError) {
            this.setState({
                isLoading: false,
                message: {
                    msg: updateTermError.message,
                    type: updateTermError.type,
                }
            })
        }

        if(prevProps.updateTermSuccess !== updateTermSuccess) {
            this.setState({
                isLoading: false,
                message: {
                    msg: updateTermSuccess.message,
                    type: updateTermSuccess.type,
                }
            })
            setTimeout(() => { 
                this.setState(this.baseState)
                this.props.hideAndResetState();
            }, 2000);
        }
    } 
    
    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    updateTerm = (e) => {

        var result = window.confirm("Confirm update?");

        if (result) {
            this.setState({
                isLoading: true
            })
            e.preventDefault();
            this.props.updateTerm(this.state, this.props.infoId);
        }
    }


    render(){

        const { message, isLoading } = this.state;

        return(

        <div>
                    
            <b className="uppercase middle">edit t&c
                <div className="title-border"></div>
            </b>

            <div className="row">
                <input type="text" id="infoName" onChange={this.handleChange.bind(this)} className="form-control" defaultValue={this.state.infoName} />
                <textarea type="text" id="infoContent" onChange={this.handleChange.bind(this)} className="form-control" defaultValue={this.state.infoContent} />
            </div>

            { isLoading === true ? 
                <small>Loading...</small>
            : 
                message  ?
                    <small className={message.type === 'updateTermError' ? "text-red" : message.type === 'updateTermSuccess'  ? "text-green" : null }>
                        {message.msg}
                    </small>
                : null
            }

            <div className="mt-5 row justify-content-end">
                <button className="btn m-2 btn-outline-black" onClick={this.updateTerm.bind(this)}><i className="fas fa-check-circle"/>{' '}update</button>
            </div>
        </div>

        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const id = ownProps.info_id;
    const infosList = state.firestore.data.infos;
    const info = infosList ? infosList[id] : null
    return {
        infoId: id,
        infosList: infosList,
        info: info,

        updateTermError: state.infos.updateTermError,
        updateTermSuccess: state.infos.updateTermSuccess,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
      updateTerm: (term, infoId) => dispatch(updateTerm(term, infoId))
    }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(EditTermAndCondition)